// Portions ISC — Lucide Icons (https://lucide.dev/license). Full notice: @air/design-icons LICENSE.
// GENERATED — do not edit. Re-run `pnpm build:icons` or edit scripts/lib/generateIcons.js.
// Source: lucide-react@1.46.0 — SVG path data inlined at codegen.

import { type IconNode } from "../../../internal/iconNode";

export const iconNode = [
  ["path", { d: "M20 6 9 17l-5-5" }],
] as const satisfies IconNode;
